import { render, staticRenderFns } from "./py.vue?vue&type=template&id=09d962cc&scoped=true"
import script from "./py.vue?vue&type=script&lang=js"
export * from "./py.vue?vue&type=script&lang=js"
import style0 from "./py.vue?vue&type=style&index=0&id=09d962cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d962cc",
  null
  
)

export default component.exports